<template>
  <form
    class="office-search-form office-search-form--district"
    :class="{ 'office-search-form--loading': loading }"
    @submit.prevent="onSubmit"
  >
    <div class="row">
      <div class="col-12 col-md-4 col-lg-2">
        <label
          class="sr-only"
          for="count"
        >
          {{ i18n.count }}
        </label>

        <div
          class="office-search-form__input-holder"
          :class="{
            'office-search-form__input-holder--invalid': $v.count.$error
          }"
        >
          <input
            id="count"
            v-model="$v.count.$model"
            class="office-search-form__input"
            type="number"
            name="count"
            :placeholder="i18n.countPlaceholder"
          >
        </div>
      </div>
      <!-- /.col -->

      <div class="col-12 col-md-4 col-lg-2">
        <label
          class="sr-only"
          for="from"
        >
          {{ i18n.from }}
        </label>

        <div
          class="office-search-form__input-holder"
          :class="{
            'office-search-form__input-holder--invalid': $v.from.$error
          }"
        >
          <input
            id="from"
            v-model="$v.from.$model"
            class="office-search-form__input"
            type="number"
            name="from"
            :placeholder="i18n.fromPlaceholder"
          >
        </div>
      </div>

      <div class="col-12 col-md-4 col-lg-2">
        <label
          class="sr-only"
          for="to"
        >
          {{ i18n.to }}
        </label>

        <div
          class="office-search-form__input-holder"
          :class="{
            'office-search-form__input-holder--invalid': $v.to.$error
          }"
        >
          <input
            id="to"
            v-model="$v.to.$model"
            class="office-search-form__input"
            type="number"
            name="to"
            :placeholder="i18n.toPlaceholder"
          >
        </div>
      </div>

      <div class="col-12 col-md-12 col-lg-5">
        <label class="sr-only">
          {{ i18n.district }}
        </label>

        <div
          class="office-search-form__input-holder"
          :class="{ 'office-search-form__input-holder--invalid': $v.districts.$error }"
        >
          <DistrictSelect
            :i18n="{ placeholder: i18n.districtPlaceholder, noResults: i18n.districtNoResults }"
            :selected-districts="selectedDistricts"
            :data-selected="districts"
            @change="onDistrictChange"
          />
        </div>
      </div>

      <div class="col-12 col-md-12 col-lg-1">
        <button
          class="office-search-form__button"
          :class="{ 'button--loading': loading }"
          type="submit"
          :disabled="loading"
        >
          <span class="sr-only">
            {{ i18n.search }}
          </span>
        </button>
      </div>
    </div>
  </form>
  <!-- /.office-search-form -->
</template>

<script>
import { numeric, required } from 'vuelidate/lib/validators';
import includes from 'lodash/includes';
import validatorUtils from '../js/mixins/validatorUtils';
import DistrictSelect from './district-select.vue';

export default {
  name: 'DistrictForm',
  components: { DistrictSelect },
  mixins: [
    validatorUtils,
  ],
  props: {
    city: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      required: false,
      default: null,
    },
    from: {
      type: Number,
      required: false,
      default: null,
    },
    to: {
      type: Number,
      required: false,
      default: null,
    },
    selectedDistricts: {
      type: [String, Number],
      required: true,
    },
    submitUrl: {
      type: String,
      required: true,
    },
    i18n: {
      type: Object,
      required: true,
      validator(data) {
        const requiredProps = [
          'count',
          'countPlaceholder',
          'districtPlaceholder',
          'districtNoResults',
          'from',
          'fromPlaceholder',
          'to',
          'toPlaceholder',
        ];

        return Object.keys(data)
          .filter((key) => includes(requiredProps, key)).length === requiredProps.length;
      },
    },
  },
  data() {
    return {
      loading: false,
      districts: [],
    };
  },
  validations: {
    count: {
      numeric,
    },
    districts: {
    },
    from: {
      numeric,
    },
    to: {
      numeric,
    },
  },
  methods: {
    onDistrictChange(districts) {
      if (!districts || districts.length === 0) {
        this.districts = [];
      }

      this.districts = districts.map(({ id }) => id);

      this.$v.districts.$touch();
    },
    onSubmit() {
      if (this.$v.$invalid) {
        this.touchAll();
        return;
      }
      this.submit();
    },
    submit() {
      const query = new URLSearchParams({
        from: this.from,
        to: this.to,
        districts: this.districts,
        count: this.count,
        city: this.city,
      }).toString();

      window.location = `${this.submitUrl}?${query}`;
    },
  },
};
</script>
